module.exports = __webpack_public_path__ + "img/ManChilltWoEsGeht.baa9bb14.jpg";